export const authReload = (shouldServeStableVersion = false) => {
  if (!shouldServeStableVersion) {
    window.location.reload();

    return;
  }

  const target = new URL(window.location.href);
  target.searchParams.set('stable', 'true');

  window.location.replace(target.href);
};
